module.exports = __webpack_public_path__ + "img/JT_icons01_64px_AddFavorites.9c37abae.svg";